import setBreakpoint from './setBreakpoint';
import getBreakpoint from './getBreakpoint';
export default {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/esm/components/core/breakpoints/index.js
// module id = null
// module chunks = 